import PropTypes from 'prop-types';
import React from 'react';
import { cx, css } from 'emotion';
import AbstractFilteredList from 'components/core/AbstractFilteredList';
import ListItem from 'components/core/ListItem';
import Flexbox from 'flexbox-react';
import RIEComboBox from 'components/core/editable/RIEComboBox';
import ProcessUtils from 'utils/ProcessUtils';
import NavigationUtils from 'utils/NavigationUtils';
import Constants from 'utils/Constants';

export default class OutputDatastreamVariableMappings extends AbstractFilteredList {

    static propTypes = {
        navId: PropTypes.string,
        datastream: PropTypes.string,
        getBackgroundColor: PropTypes.func,
        getCoordinateSystem: PropTypes.func,
        outputstreamVariables: PropTypes.array,
        baseFieldPath: PropTypes.array,
        process: PropTypes.object,
        processErrors: PropTypes.object,
        revisionNum: PropTypes.string
    };

    match(regex, name, value) {
        return (name.search(regex) > -1 || value.search(regex) > -1);
    }

    getItemClassName() {
        return 'entity output-datastream-mappings';
    }

    getListClassName() {
        return 'entity-list output-datastream-mappings';
    }

    getOutputstreamVariableOptions = () => {
        const options = Constants.convertArrayToSelectOptions(this.props.outputstreamVariables);
        Constants.sortSelectOptions(options);
        return options;
    };

    onOutputstreamVariableChange = (fieldPath, value) => {
        ProcessUtils.updateField(this.props.process, fieldPath, value);
    };

    render() {
        // I am setting these local variables because they are always reset when rendering, so it won't get
        // clobbered when switching tabs
        this.color = AbstractFilteredList.COLOR_WHITE;
        return super.render();
    }

    renderHeaderSection() {
        const headerStyle = css`flex-shrink: 0;`;

        return (
            <Flexbox flexDirection="row" className={cx('header-section', headerStyle)}>
                <Flexbox flexGrow={1} style={{ width: '50%' }}>Populate output datsatream variable:</Flexbox>
                <Flexbox flexGrow={1} style={{ width: '50%' }}>With retrieved variable:</Flexbox>
            </Flexbox>
        );
    }

    renderItem(retrievedVariableName, outputVar, selected) {
        const dimensions = ProcessUtils.getRetrievedVariableDimensions(this.props.process, retrievedVariableName);

        const fieldPath = [...this.props.baseFieldPath, retrievedVariableName];
        const onNavClick = NavigationUtils.gotoRetrievedVariableFunc(this.props.navId, this.props.revisionNum, retrievedVariableName);

        return (
            <ListItem
                key={retrievedVariableName}
                name={retrievedVariableName}
                className={this.getItemClassName()}
                selected={selected}
            >
                <Flexbox flexDirection="row">
                    <Flexbox flexGrow={1} style={{ width: '50%' }} className="list-cell">
                        <RIEComboBox
                            value={{ value: outputVar, label: outputVar }}
                            options={this.getOutputstreamVariableOptions()}
                            multi={false}
                            change={this.onOutputstreamVariableChange}
                            fieldPath={fieldPath}
                            onChangeData={{ retrievedVariableName }}
                            clearable
                            creatable
                            isDisabled={!this.props.hasWritePermissions}
                            processId={this.props.process.name}
                            processErrors={this.props.processErrors}
                        />
                    </Flexbox>
                    <Flexbox flexGrow={1} style={{ width: '50%', overflow: 'hidden' }} className="list-cell" onClick={this.onClick} onDoubleClick={onNavClick}>
                        <Flexbox flexDirection="row" alignItems="center">
                            <span className="badged-item-label">
                                {this.renderEntity(retrievedVariableName, dimensions)}
                            </span>
                        </Flexbox>
                    </Flexbox>
                </Flexbox>
            </ListItem>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/variableRetrieval/outputs/OutputDatastreamVariableMappings.js